// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2Ms6j","amount":"Amount_amount__30Btx","tip":"Amount_tip__3oMlb","tipHeader":"Amount_tipHeader__3gKkC","tipsWrap":"Amount_tipsWrap__o92al"};